<template lang="pug">
  v-dialog(v-model='dialog' fullscreen hide-overlay transition="dialog-bottom-transition")
    template(v-slot:activator='{ on }')
      v-list-tile(v-on='on')
        v-list-tile-title {{ $t('buttons.view') }}
    v-card
      v-toolbar(height="45" color='blue-grey darken-1' dark)
        v-toolbar-title
          h1.subheading {{ $t('pageHeader.appeal') }}
        v-spacer
        Status(v-if="appealValue" :statusID="appealValue.statusID" :name="appealValue.appealStatusDetail.selector")
        v-btn(icon, @click='close()')
          v-icon close
      v-card-text
        v-container(fluid grid-list-md)
          div.text-xs-center.title.black--text.font-weight-regular Phone Information
          v-layout(align-center justify-space-around row fill-height wrap)
            v-flex

              div.pt-2.subheading.grey--text {{ $t('labels.invoiceDate') }}:
                span.subheading.black--text.ml-2.font-weight-regular {{ appealValue.invoiceDate | moment("MM/DD/YYYY") }}

              div.pt-2.subheading.grey--text {{ $t('labels.phoneNumber') }}:
                span.subheading.black--text.ml-2.font-weight-regular {{ appealValue.phoneNumber }}

              div.pt-2.subheading.grey--text {{ $t('labels.saleType') }}:
                span.subheading.black--text.ml-2.font-weight-regular {{ appealValue.saleTypeDetail.selector }}

              div.pt-2.subheading.grey--text {{ $t('labels.phoneName') }}:
                span.subheading.black--text.ml-2.font-weight-regular {{ appealValue.phoneName }}

              div.pt-2.subheading.grey--text {{ $t('labels.imeiNumber') }}:
                span.subheading.black--text.ml-2.font-weight-regular {{ appealValue.IMEINumber }}
              div.pt-2.subheading.grey--text(v-if="appealValue.additionalIMEINumber") {{ $t('labels.additionalIMEINumber') }}
                span.subheading.black--text.ml-2.font-weight-regular {{ appealValue.additionalIMEINumber }}
              
            v-flex
              v-textarea(v-model="appeal.note" rows="8" label="Note")  
          v-divider
          div.pt-3.text-xs-center.title.black--text.font-weight-regular Appeal Information
          v-layout(align-center justify-space-around row fill-height wrap)
            v-flex
              div.pt-2.subheading.grey--text {{ $t('labels.appealStatus') }}
                span.subheading.black--text.ml-2.font-weight-regular {{ appealValue.appealStatusDetail.selector }}
              div.pt-2.subheading.grey--text {{ $t('labels.appealDate') }}
                span.subheading.black--text.ml-2.font-weight-regular {{ appealValue.appealDate | moment("MM/DD/YYYY") }}
              div.pt-2.subheading.grey--text {{ $t('labels.amount') }}
                span.subheading.black--text.ml-2.font-weight-regular {{ appealValue.amount | currency }}
              div.pt-2.subheading.grey--text {{ $t('labels.appealFor') }}
                span.subheading.black--text.ml-2.font-weight-regular {{ appealValue.appealFor }}
              div.pt-2.subheading.grey--text {{ $t('labels.receivedDate') }}
                span.subheading.black--text.ml-2.font-weight-regular {{ appealValue.receivedDate | moment("MM/DD/YYYY") }}
              div.pt-2.subheading.grey--text {{ $t('labels.amount') }}
                span.subheading.black--text.ml-2.font-weight-regular {{ appealValue.receivedAmount | currency }}             
              
          v-layout.pt-2(row wrap)
            v-flex(xs12 sm6)
              DateTimePicker(:showIcon="false"
                :range="false"
                :clearable="false"
                :hideTime="true"
                label="Appeal Date"
                v-on:input="setDueDate" 
                :initStartDate="$moment(new Date())" 
                :noFuture="true")
            v-flex(xs12 sm6)
              v-text-field(v-model="appeal.appealID" :error-messages="appealIDErrors" label='Appeal ID')  
            v-flex(xs12)
              v-radio-group(v-model='appeal.statusID', row)
                v-radio(label='Accepted', value='183')
                v-radio(label='Error', value='184')
            v-flex(xs12)    
              v-textarea(v-model="appeal.note" label="Note")  

                
      v-card-actions
        v-spacer
        v-btn(color='info', flat, @click='close()') Close
        v-btn(color='info' dark @click='update()') Save
      
</template>

<script>
import { mapGetters } from "vuex";
import AppealService from "../service.js";
import DateTimePicker from "../../../Global/components/DateTimePicker";
const Status = () => import('./StatusComponent')
const { validationMixin } = require("vuelidate");
const { required, minLength, minValue } = require("vuelidate/lib/validators");

export default {
  props: {
    appealValue: {
      default: null
    },
  },
  name: "create-reconcile",
  data() {
    return {
      dialog: false,
      appealFor: null,
      appeal: {
        statusID: '183',
        appealDate: new Date(),
        note: null,
        appealID: null,
      }
    };
  },
  mixins: [validationMixin],
  validations: {
    appeal: {
      appealID: {
        required
      }
    }
  },
  computed: {
    darkStatus() {
      let color = null
      switch(this.appealValue.statusID) {
        case 183: // Accepted
          color = true
          break
        case 184: // Error
          color = true
          break
        case 185: // Denied
          color = true
          break
        case 186: // Got Paid
          color = true
          break
        case 187: // Waiting For Appeal
          color = false
          break
        default:
          color = true
      }
      return color     
    },
    status() {
      let color = null
      switch(this.appealValue.statusID) {
        case 183:
          color = 'info'
          break
        case 184:
          color = 'deep-purple accent-1'
          break
        case 185:
          color = 'red'
          break
        case 186:
          color = 'green accent-4'
          break
        case 187:
          color = 'yellow'
          break
        default:
          color = 'info'
      }
      return color     
    },
    appealIDErrors() {
      const errors = [];
      if (!this.$v.appeal.appealID.$dirty) return errors;
      if (!this.$v.appeal.appealID.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      return errors;
    }
  },
  components: {
    DateTimePicker,
    Status
  },
  watch: {
    dialog(val) {
      if (val) {
        this.appealFor = this.appealValue.appealFor
        this.id = this.appealValue.id
      }
    }
  },
  methods: {
    empty() {
      this.appealFor = null
      this.id = null
      this.appeal = {
        appealDate: new Date(),
        appealID: null,
        note: null,
      }
    },
    setDueDate(val) {
      this.appeal.appealDate = val;
    },
    close() {
      this.empty()
      this.dialog = false
    },
    update() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000
          }).fire({
            type: "error",
            title: this.$t("toastMessage.text.invalidFields")
          });
      } else {
        AppealService.update(this.id, this.appeal)
        .then(result => {
          this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000
          }).fire({
            type: "success",
            title: "Appeal was saved!"
          });
          this.close()
          this.$emit("created");
        });
      }
    }
  }
}
</script>
<style scoped>
  .v-dialog__container {
    display: none !important;
  }
</style>
